/**
 * Testimonials carousel.
 */

const initTestimonials = () => {
  document.querySelectorAll('[data-testimonials]').forEach((root) => {
    const section = root.closest('.home-testimonials') || root.parentElement;
    const prev = section?.querySelector('[data-testimonials-prev]');
    const next = section?.querySelector('[data-testimonials-next]');
    const item = root.querySelector('.home-testimonial');
    if (!item) return;

    const amount = () => {
      const list = root.querySelector('.home-testimonials-list');
      const gap = list ? parseFloat(getComputedStyle(list).gap) || 24 : 24;
      return item.getBoundingClientRect().width + gap;
    };

    const syncNav = () => {
      const max = Math.max(0, root.scrollWidth - root.clientWidth);
      const left = root.scrollLeft;
      const atStart = left <= 2;
      const atEnd = left >= max - 2 || max <= 0;

      if (prev) {
        prev.disabled = atStart;
        prev.classList.toggle('is-disabled', atStart);
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd;
        next.classList.toggle('is-disabled', atEnd);
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    };

    prev?.addEventListener('click', () => {
      root.scrollBy({ left: -amount(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      root.scrollBy({ left: amount(), behavior: 'smooth' });
    });

    root.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();
  });
};

export default initTestimonials;
